import { Component } from 'react';
import PropTypes from 'prop-types';

class TableHeadComponent extends Component {
  render() {
    const { columnNames } = this.props;

    const headerRow = columnNames.map(th => (
      <th key={th}>{th}</th>
    ));

    return (
      <thead>
        <tr>
          {headerRow}
        </tr>
      </thead>
    );
  }
}

TableHeadComponent.propTypes = {
  columnNames: PropTypes.arrayOf(PropTypes.string),
};

TableHeadComponent.defaultProps = {
  columnNames: [],
};

export default TableHeadComponent;
